import Button from "components/common/Button";
import SmsIcon from "assets/images/SupportAndChat/SmsIcon.png"
import { BiLogoWhatsapp, BiPhone } from "react-icons/bi"


const ForCall: React.FC<{ toggle: () => void }> = ({ toggle }) => {
    return (<>
        <div className="py-10 flex flex-col h-full items-center justify-center">
            <img
                className="mb-7"
                src={SmsIcon}
                alt="Icon" />

            <p className="font-[400] text-[16px] text-dark0b mb-3">Hi, send us an SMS or Call today.</p>

            <div className="lg:w-[50%] flex flex-col items-center justify-center">
                <p className="mb-10 text-center font-[400] text-[14px] text-textGrey/70">
                    Our phone lines are open on weekdays from <span className="text-danger">8:00 am</span> to <span className="text-danger">6:00 pm.</span> Tap the button below to call us.
                </p>
                <Button buttonType="primary" size="md" className="!flex items-center"><BiPhone className="mr-2" /> 08129445935</Button>
            </div>


        </div>
    </>);
}

export default ForCall;